import { Injectable, signal } from '@angular/core';
import { StatusMessageType } from '@shared/components/status-message-widget/status-message-widget.component';

@Injectable({
  providedIn: 'root',
})
export class StatusMessageService {
  private hideTimeout: any;

  public message = signal<string | null>(null);
  public type = signal<StatusMessageType>(StatusMessageType.Info);

  public show(message: string, type: StatusMessageType = StatusMessageType.Info) {
    this.message.set(message);
    this.type.set(type);

    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }

    this.hideTimeout = setTimeout(() => {
      this.clear();
    }, 3000);
  }

  public clear() {
    this.message.set(null);
  }
}
